import template from './adpComponentsList.html';
import controller from './adpComponentsList.controller';
import './adpComponentsList.less';

let adpComponentsListComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: true,
  controller
};

export default adpComponentsListComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentsList/adpComponentsList.component.js